export const NEWS_STORAGE_KEY = 'news';
export const NEWS_MODAL_STORAGE_KEY = 'news_modal';
